import { render, staticRenderFns } from "./BarOrderPanel.vue?vue&type=template&id=54b6dfe1&scoped=true"
import script from "./BarOrderPanel.vue?vue&type=script&lang=js"
export * from "./BarOrderPanel.vue?vue&type=script&lang=js"
import style0 from "./BarOrderPanel.vue?vue&type=style&index=0&id=54b6dfe1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6dfe1",
  null
  
)

export default component.exports